export const MD_WIDTH = '90%';
export const SM_WIDTH = '95%';

export const MAX_WIDTH = '1440px';
